// 栅格瓦片解析配置项

export let RasterTileType = /*#__PURE__*/function (RasterTileType) {
  RasterTileType["IMAGE"] = "image";
  RasterTileType["CUSTOMIMAGE"] = "customImage";
  RasterTileType["ARRAYBUFFER"] = "arraybuffer";
  RasterTileType["RGB"] = "rgb";
  RasterTileType["TERRAINRGB"] = "terrainRGB";
  RasterTileType["CUSTOMRGB"] = "customRGB";
  RasterTileType["CUSTOMARRAYBUFFER"] = "customArrayBuffer";
  RasterTileType["CUSTOMTERRAINRGB"] = "customTerrainRGB";
  return RasterTileType;
}({});

// 解析后返回数据类型